import styled from "styled-components";
import {Title1} from "../../../../styles/business-components";

export const Container = styled.div`
  padding: 50px 200px 100px 200px;
`

export const Title = styled(Title1)`
  text-align: center;
`

export const Grid = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: repeat(auto-fill, 1fr);
  text-align: center;
  margin-top: 100px;
`

export const Cell = styled.div`
  border-radius: 30px;
  padding: 10px;
  background: ${({theme}) => theme.business.colors.functionalRateCellBackground};
  color: ${({theme}) => theme.business.colors.functionalRateCellColor};
  font-size: 24px;
  font-weight: 600;
  line-height: 60px;
`

export const CellAccent = styled(Cell)`
  text-transform: uppercase;
  color: ${({theme}) => theme.business.colors.primary};
`